export default __webpack_public_path__ + "static/media/cfa_logo_without_tm.3c6ef0a1.svg";